<template>
  <div v-if="page.about" class="page page-white page-about">
    <AboutMainText/>
    <div class="about-map">
      <img src="/static/map_white.svg"/>
      <!-- <Cities/> -->
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

import AboutMainText from '@/components/AboutMainText';
import Cities from '@/components/Cities';


export default {
  name: 'about',
  components: {
    AboutMainText,
    Cities,
  },
  computed: mapGetters({
    page: 'page',
  }),
};
</script>


<style>
.about{
  &-main-text{
    @media (min-width: $mediaIpad) {
      margin-bottom: -150px;
      display: inline-block;
    }
  }
  &-map{
    @media (min-width: $mediaIpad) {
      max-width: 100%;
      width: 100%;
      z-index: -1;

      .page-back &{
        margin-top: 0;
        z-index: 20;
      }

      .page-front &{
        margin-left: 0;
      }
      img{
        margin: 0;
        width: 110%;
      }  
    }

    @media (max-width: $mediaIpad) {
      display: none;
    }

    @media (max-width: $mediaIpad) {
      &,
      img{
        margin-top: 0;
      }
    }
  }
}

  .col-stat{
    @media (min-width: 990px) {
      margin-top: 105px;
    }

    a{
      color: black;

      &:hover{
        color: #ff9933;
      }
    }
  }

.page-about{
  p{
    span{
      vertical-align: bottom;
      max-width: 500px;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/AboutUs.vue